import { ISliderProps, Slider } from "native-base";
import React from "react";
import { IS_MOBILE } from "../locales/translate";

type Props = ISliderProps & {};

const SliderBase = (props: Props) => {
  const { style, ...rest } = props;
  return (
    <Slider
      {...rest}
      style={[style,
        //  { transform: [{ rotate: IS_MOBILE ? "180deg" : "deg" }] }
        ]}
      // isReversed
    >
      <Slider.Track>
        <Slider.FilledTrack />
      </Slider.Track>
      <Slider.Thumb style={IS_MOBILE && { marginLeft: -12 }} />
    </Slider>
  );
};

export default SliderBase;
